import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import PracticePage from "@/pages/PracticePage";
import { Toaster } from "@/components/ui/sonner";

const PRACTICE_SLUGS = ["familia", "sucesiones", "laboral", "accidentes-de-transito"];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          {PRACTICE_SLUGS.map((slug) => (
            <Route key={slug} path={`/${slug}`} element={<PracticePage slug={slug} />} />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
